<div class="container-filter-cards">
  <div class="container-breadcrumb">
    <p id="id-breadcrumb-category" class="copec-lg-14">
      Categorías / <span class="ruta"> Crear Nueva Categoría /</span>
    </p>
  </div>
  <div class="container-button-subtitle">
    <div class="box-button1">
      <span class="copec-bold-30">Crear Nueva Categoría</span>
    </div>
    <div class="box-button2">
      <button class="button-guardar" (click)="openDialog()">Guardar</button>

      <button class="button-publicar">Publicar Categoría</button>
    </div>
  </div>

  <div>
    <div>
      <div class="accordion-box">
        <h2 class="copec-rg-20">Información Básica de la Categoría</h2>
        <div>
          <div>
            <div class="box-description">
              <span
                >Ingresa aquí la información básica de la categoría. Todos los
                campos son obligatorios.
              </span>
            </div>
            <div class="box-label">
              <h2 class="copec-rg-14">Nombre de la Categoría</h2>
            </div>
            <form
              method="get"
              action="javascript: void(0);"
              id="login-form"
              class="login-form"
              autocomplete="off"
              role="main"
            >
              <div>
                <label class="label-cat">
                  <input
                    type="text"
                    class="text"
                    name="nombrecategoria"
                    placeholder=""
                    tabindex="1"
                    value="Bienestar Laboral"
                  />
                </label>
              </div>
              <div class="espacio"></div>
              <div>
                <label class="label-cat">
                  <mat-form-field>
                    <mat-label>Buscador de Beneficios</mat-label>
                    <input
                      type="text"
                      placeholder="
                      #fruitInput
                      aria-label=Beneficios"
                      matInput
                      [formControl]="myControl"
                      [matAutocomplete]="auto"
                    />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      (optionSelected)="selected($event)"
                    >
                      <mat-option
                        *ngFor="let benefit of filteredBenefits | async"
                        [value]="benefit.title"
                      >
                        {{ benefit.title }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </label>
              </div>
              <div class="espacio2"></div>
              <div>
                <label class="label-cat">
                  <mat-form-field class="example-chip-list">
                    <mat-label
                      >Los beneficios seleccionados aparecerán en este
                      espacio</mat-label
                    >
                    <mat-chip-grid #chipGrid aria-label="Enter fruits">
                      <mat-chip-row
                        *ngFor="let beneficio of seleccionados"
                        (removed)="remove(beneficio)"
                        [editable]="false"
                      >
                        <span class="mat-chip-autocomplete">{{
                          beneficio
                        }}</span>
                        <button matChipRemove [attr.aria-label]="'remove'">
                          <mat-icon class="buttonChip">cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                      <input
                        placeholder=""
                        [matChipInputFor]="chipGrid"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur"
                      />
                    </mat-chip-grid>
                  </mat-form-field>
                </label>
              </div>
              <div class="espacio2"></div>
              <div class="box-label">
                <h2 class="copec-rg-14">Icono</h2>
              </div>
              <div>
                <label class="label-cat">
                  <span class="labelicono"
                    ><br /><br /><img
                      _ngcontent-ng-c1758309562=""
                      class="imgicono"
                      id="cat-cat-img-1-1"
                      src="/assets/icono/icon-categorias.svg"
                      aria-hidden="true"
                      alt="Categorias"
                  /></span>
                  <span
                    >.PNG,.SVG,.Dimensiones Óptimas 24x24px. Máximo 2MB</span
                  >
                </label>
              </div>
              <div>
                <br />
                <label class="label-cat">
                  <div class="button-container">
                    <button class="sharp-button">
                      Cambiar icono
                      <i class="icon"
                        ><img
                          _ngcontent-ng-c1758309562=""
                          class="imgicono"
                          id="cat-cat-img-1-1"
                          src="/assets/icono/icon-edit.svg"
                          aria-hidden="true"
                          alt="Cambiar icono"
                      /></i>
                      <!-- Puedes reemplazar esto con el código o nombre de tu icono -->
                    </button>
                    <button class="sharp-button">
                      Eliminar icono
                      <i class="icon"
                        ><img
                          _ngcontent-ng-c1758309562=""
                          class="imgicono"
                          id="cat-cat-img-1-1"
                          src="/assets/icono/icon-delete.svg"
                          aria-hidden="true"
                          alt="Eliminar icono"
                      /></i>
                      <!-- Puedes reemplazar esto con el código o nombre de tu icono -->
                    </button>
                  </div>
                </label>
              </div>
              <div class="espacio2"></div>
              <div class="box-label">
                <h2 class="copec-rg-14">Estado</h2>
              </div>
              <div class="radio-container">
                <input
                  type="radio"
                  name="opcion"
                  value="opcion1"
                  class="radiostyle"
                />Borrador
                <input
                  type="radio"
                  name="opcion"
                  value="opcion1"
                  class="radiostyle"
                />Publicado
                <input
                  type="radio"
                  name="opcion"
                  value="opcion1"
                  class="radiostyle"
                />Oculto
              </div>
            </form>
          </div>
        </div>
        <div class="box-description2"></div>
        <div class="container-button-subtitle2">
          <div class="box-button1"><span class="copec-bold-30"> </span></div>
          <div class="box-button2">
            <button class="button-guardar" (click)="openDialog()">
              Guardar
            </button>

            <button class="button-publicar">Publicar Categoría</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
